import { render, staticRenderFns } from "./TopDynamic.vue?vue&type=template&id=dc255846&scoped=true"
import script from "./TopDynamic.vue?vue&type=script&lang=js"
export * from "./TopDynamic.vue?vue&type=script&lang=js"
import style0 from "./TopDynamic.vue?vue&type=style&index=0&id=dc255846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc255846",
  null
  
)

export default component.exports